import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectAutoAcceptOrdersNotifications,
  selectNewOrdersNotifications,
  selectSystemNotifications
} from '@/ducks/notifications/selectors/notificationsSelectors'
import {
  addAutoAcceptOrderNotification,
  addNewOrderNotification,
  addSystemNotification,
  IToast,
  removeNotificationNew
} from '@/ducks/notifications/slices/notification.slice'

export const useToaster = () => {
  const dispatch = useDispatch()

  const system = useSelector(selectSystemNotifications)
  const newOrders = useSelector(selectNewOrdersNotifications)
  const autoAcceptOrders = useSelector(selectAutoAcceptOrdersNotifications)

  const addToast = useCallback(
    (toast: IToast) => {
      if (toast.type === 'newOrder') {
        dispatch(addNewOrderNotification(toast))
      } else if (toast.type === 'autoAcceptOrder') {
        dispatch(addAutoAcceptOrderNotification(toast))
      } else {
        if (toast.type === 'system')
          dispatch(addSystemNotification({ ...toast, type: 'system' }))
      }
    },
    [dispatch]
  )

  const removeToast = useCallback(
    (id: number) => {
      dispatch(removeNotificationNew(id))
    },
    [dispatch]
  )

  return {
    system,
    newOrders,
    autoAcceptOrders,
    addToast,
    removeToast
  }
}
